module.exports = __webpack_public_path__ + "img/logo_rocket-league_white-01.e31afa74.svg";